import React, { Component } from "react"
import { withStyles } from "@material-ui/core"
import * as constants from "../constants"
import { Cookies } from "react-cookie"
import Grid from "@material-ui/core/Grid"
import Divider from "@material-ui/core/Divider"
import FloatingLabelInput from "./FloatingLabelInput"
import Select from "react-select"
import Button from "@material-ui/core/Button"
import Fab from "@material-ui/core/Fab"
import EditIcon from "@material-ui/icons/Edit"
import DeleteIcon from "@material-ui/icons/Delete"
import Snackbar from "@material-ui/core/Snackbar"
import { Alert, AlertTitle } from "@material-ui/lab"

const styles = (theme) => ({
      button: {
            margin: theme.spacing.unit,
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

class ResponsdoctorsDamage extends Component {

      cookies = new Cookies()
      constructor(props) {

            super(props)

            this.state = {
                  responsdoctorsDamageState: this.props.responsdoctorsDamage,
                  selectedResponsdoctorsDamage: {
                        value: this.props.responsdoctorsDamage.responsdoctors_price_damage_responsdoctors_damage_id,
                        label: this.props.responsdoctorsDamage.responsdoctors_damage_name,
                  },
                  responsdoctorsParamedicDamageState:this.props.responsdoctorsDamage.responsdoctors_price_paramedic_damage_percent,
                  visible: true,
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
            }
      }
      componentDidMount() {
            this.getoptionResponsdoctorsDamage()
      }

      getoptionResponsdoctorsDamage = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].responsdoctors_damage_id, label: arr.data[k].responsdoctors_damage_name })
                              }
                              self.setState({ optionResponsdoctorsDamage: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_responsdoctors_damage")
            xhttp.open("POST", `${constants.BASE_URL}/responsdoctors`)
            xhttp.send(fd)
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleResponsdoctorsDamage = (selectedResponsdoctorsDamage) => {
            var temparray = this.state.responsdoctorsDamageState
            temparray.responsdoctors_price_damage_responsdoctors_damage_id = selectedResponsdoctorsDamage.value
            this.setState({ selectedResponsdoctorsDamage: selectedResponsdoctorsDamage, responsdoctorsDamageState: temparray })
      }

      handleChangeConditionsPercent = (event) => {
            console.log("##########", event);

            var temparray = this.state.responsdoctorsDamageState
            temparray.responsdoctors_price_damage_percent = event
            this.setState({ responsdoctorsDamageState: temparray })
      }

      handleChangeConditionsPercent_paramedic = (event) => {
            console.log("************", event);
            var temparray = this.state.responsdoctorsDamageState
            temparray.responsdoctors_paramedic_price_damage_percent = event
            this.setState({ responsdoctorsDamageState: temparray })
      }

      modifyNewInstalmentCondition = () => {
            const { responsdoctorsDamageState } = this.state

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "modify_price_damage")
            fd.append("responsdoctors_price_damage_id", responsdoctorsDamageState.responsdoctors_price_damage_id)
            fd.append("responsdoctors_price_damage_percent", responsdoctorsDamageState.responsdoctors_price_damage_percent)
            fd.append("responsdoctors_paramedic_price_damage_percent", responsdoctorsDamageState.responsdoctors_paramedic_price_damage_percent)

            xhttp.open("POST", `${constants.BASE_URL}/responsdoctors`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      deleteInstalmentCondition = () => {
            const { responsdoctorsDamageState } = this.state

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ visible: false, snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "delete_price_damage")
            fd.append("responsdoctors_price_damage_id", responsdoctorsDamageState.responsdoctors_price_damage_id)

            xhttp.open("POST", `${constants.BASE_URL}/responsdoctors`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      render() {
            const { classes } = this.props
            const {
                  optionResponsdoctorsDamage,
                  snackMode,
                  snackstr,
                  showSnack,
                  visible,
                  selectedResponsdoctorsDamage,
                  responsdoctorsDamageState,
            } = this.state
            if (visible) {
                  return (
                        <Grid container spacing={3}>
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>

                              <Grid item xs={5}>
                                    <div>
                                          <label className="on"> پوشش بیمه</label>
                                          <Select
                                                isSearchable={true}
                                                className="adapter-txtsize"
                                                placeholder={"پوشش بیمه"}
                                                value={selectedResponsdoctorsDamage}
                                                onChange={this.handleResponsdoctorsDamage}
                                                options={optionResponsdoctorsDamage}
                                          />
                                    </div>
                              </Grid>

                              <Grid item xs={2}>
                                    <FloatingLabelInput
                                          type="percent"
                                          placeholder=" درصد تخفیف پزشک"
                                          handleInputt={this.handleChangeConditionsPercent}
                                          value={responsdoctorsDamageState.responsdoctors_price_damage_percent}
                                    />
                              </Grid>


                              <Grid item xs={2}>
                                    <FloatingLabelInput
                                        type="percent"
                                        placeholder="درصد تخفیف پیرا پزشک"
                                        handleInputt={this.handleChangeConditionsPercent_paramedic}
                                        value={responsdoctorsDamageState.responsdoctors_paramedic_price_damage_percent}
                                    />
                              </Grid>

                              <Grid item xs={3}>
                                    <div style={{ width: "100%", textAlign: "left" }}>
                                          <Fab
                                                className={classes.small}
                                                style={{ background: "#44b700" }}
                                                aria-label="edit"
                                                onClick={this.modifyNewInstalmentCondition}
                                          >
                                                <EditIcon />
                                          </Fab>

                                          <Fab className={classes.small} color="secondary" aria-label="edit" onClick={this.deleteInstalmentCondition}>
                                                <DeleteIcon />
                                          </Fab>
                                    </div>
                              </Grid>
                              <Grid item xs={12}>
                                    <Divider />
                              </Grid>
                        </Grid>
                  )
            } else {
                  return null
            }
      }
}
export default withStyles(styles)(ResponsdoctorsDamage)
